import { render, staticRenderFns } from "./StorefrontContainer.vue?vue&type=template&id=b9a405be&"
import script from "./StorefrontContainer.vue?vue&type=script&lang=js&"
export * from "./StorefrontContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports